// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DoSj","name":"styles_name__3KRPf","phone":"styles_phone__2GMdQ"};